import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-100 d-flex align-center justify-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " Presionando el botón \"Descargar\" podrás generar y descargar un archivo excel con los resultados de todas las encuestas realizadas por este sistema. ", -1)

import { ExcelGeneratorService } from '@/services/excel-generator/excelGeneratorService';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadResultsView',
  setup(__props) {

const excelGeneratorService = new ExcelGeneratorService();
const downloadingResults = ref(false)
const isDownloaded = ref(false)
const hasError = ref(false)

async function downloadResults() {
    isDownloaded.value = false
    hasError.value = false

    downloadingResults.value = true
    const response = await excelGeneratorService.downloadExcelFile()
    downloadingResults.value = false

    console.log(response);
    
    if (response) {
        isDownloaded.value = true
    } else {
        hasError.value = true
    }
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, { "max-width": "400px" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, null, {
          default: _withCtx(() => [
            _createTextVNode(" Descargar Resultados ")
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, { class: "d-flex flex-column ga-2" }, {
          default: _withCtx(() => [
            _hoisted_2,
            (isDownloaded.value)
              ? (_openBlock(), _createBlock(_component_v_alert, {
                  key: 0,
                  type: "success",
                  dense: "",
                  dismissible: "",
                  border: "start",
                  icon: "mdi-check",
                  variant: "tonal"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Archivo descargado correctamente. Revise su carpeta de descargas. ")
                  ]),
                  _: 1
                }))
              : (hasError.value)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 1,
                    type: "error",
                    dense: "",
                    dismissible: "",
                    border: "start",
                    icon: "mdi-alert",
                    variant: "tonal"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ha ocurrido un error al intentar descargar el archivo. Por favor, inténtelo nuevamente. Si el error persiste, contacte al administrador del sistema. ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_actions, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              color: "primary",
              onClick: downloadResults,
              "prepend-icon": "mdi-download",
              loading: downloadingResults.value,
              block: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Descargar ")
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})